<nz-table
  #nzTable
  [nzData]="list"
  nzTableLayout="fixed"
  [nzShowPagination]="false"
>
<thead>
  <tr>
    <th nzWidth="60px"></th>
    <th *ngFor="let item of columns" (click)="item.hasSort && onSortBy(item.key)"
    [nzSortFn]="item.sortFn"
    [nzSortDirections]="['ascend', 'descend', null]"
    [nzFilters]="item.filters"
    [nzFilterFn]="item.filterFn">
      {{ item.columnLabel | translate }}
      <span
        [translatable]="{
          transKey: item.columnLabel,
          modEnum: translationModulesEnum[modEnum]
        }"
      ></span>
    </th>
  </tr>
</thead>
  <tbody>
    <ng-container
      *ngFor="
        let data of list
          | paginate
            : {
                itemsPerPage: paginationModel?.pageSize,
                currentPage: paginationModel?.pageIndex,
                totalItems
              };
        let i = index
      "
    >
      <tr>
        <!-- Row Checkbox -->
        <td *ngIf="showCheckBoxes">
          <input
            type="checkbox"
            [(ngModel)]="data.selected"
            (change)="onRowSelect(data)"
          />
        </td>

        <!-- Expand/Collapse Button -->
        <td
          [nzExpand]="expandSet.has(data.id)"
          (nzExpandChange)="onExpandChange(data.id, $event)"
        >
          <span (click)="onExpandChange(data.id, !expandSet.has(data.id))">
            <img
              class="cursor-pointer"
              src="{{
                expandSet.has(data.id)
                  ? 'assets/icons/angle-down-small.svg'
                  : 'assets/icons/angle-right-small.svg'
              }}"
              alt="expand"
            />
          </span>
        </td>

        <!-- Data Columns -->
        <ng-container *ngFor="let column of columns; let j = index">
          <td *ngIf="column.type === 'link'">
            <a class="hoverableLink" [routerLink]="link + data?.id">
              {{ data?.[column.key] }}
            </a>
          </td>
          <td *ngIf="column.type === 'photo'">
            <a class="hoverableLink" [routerLink]="link + data?.id">
              <img
                [src]="data?.[column.key]"
                [style.width.px]="column?.width ? column.width : 50"
                [style.height.px]="column?.height ? column.height : 50"
                alt="photo"
                class="table-photo"
              />
            </a>
          </td>
          <td *ngIf="column.type === 'text'">
            <span>
              {{ data?.[column.key] }}
            </span>
          </td>
          <td *ngIf="column.type === 'textName'">
            <span>
              {{ data?.[column.key].name }}
            </span>
          </td>
          <td *ngIf="column.type === 'list'">
            <span
              *ngFor="let item of data?.[column.key]; let i = index; let isLast = last"
            >
              {{ item }}
              <span *ngIf="!isLast">,</span>
            </span>
          </td>
          <td *ngIf="column.type === 'innerHTMLText'">
            <span [innerHTML]="data?.[column.key]"></span>
          </td>
          <td *ngIf="column.type === 'date'">
            <span class="opacity-50">
              {{
              translate.store.currentLang === "en"
              ? (data?.[column.key] | date : "d MMM y" : "UTC")
                : (data?.[column.key] | localizeDate : "d MMM y")
              }}
            </span>
          </td>
          <td *ngIf="column.type === 'dateTime'">
            <span class="opacity-50">
              {{
              translate.store.currentLang === "en"
                ? (data?.[column.key] | date : "d MMM y / h:mm a" : "UTC")
                : (data?.[column.key] | localizeDate : "d MMM y / h:mm a")
              }}
            </span>
          </td>
          <td *ngIf="column.type === 'time'">
            <span class="opacity-50">
              {{
              lang === "en"
                ? (data?.[column.key] | date : "h:mm a" : "UTC")
                : (data?.[column.key] | localizeDate : "h:mm a")
              }}
            </span>
          </td>
          <td *ngIf="column.type === 'status'">
            <ng-container
              *ngIf="
                column.parentComponent &&
                  column.parentComponent == 'paymentInformation';
                else object_status
              "
            >
              <span *ngIf="data?.status">
                <app-badge
                  [className]="data?.status?.toLowerCase()"
                  [label]="data?.[column.key]"
                ></app-badge>
              </span>
            </ng-container>
            <ng-template #object_status>
              <span *ngIf="data?.status">
                <ng-container *ngIf="column.enum; else normalBadge">
                  <app-status-flag
                    [statusName]="data?.status?.name?.toLowerCase()"
                    [statusCode]="data?.status?.id"
                    [statusMap]="column.enum"
                  ></app-status-flag>
                </ng-container>
                <ng-template #normalBadge>
                  <app-badge
                    [className]="
                      data?.status?.name?.toLowerCase() == 'in active'
                        ? 'offTrack'
                        : data?.status?.name?.toLowerCase()
                    "
                    [label]="data?.[column.key].name"
                  ></app-badge>
                </ng-template>
              </span>
            </ng-template>
          </td>
          <td *ngIf="column.type === 'actions' && column.buttons">
            <div class="d-flex justify-content-start align-items-center gap-2">
              <ng-container *ngFor="let button of column.buttons">
                <div
                  *ngIf="shouldShowButton(button, data)"
                  [translatable]="{
                    transKey: button.label,
                    modEnum: button.modEnum
                  }"
                >
                  <button
                    [ngClass]="button.className"
                    (click)="handleAction(button.actionType, data)"
                  >
                    {{ button.label | translate }}
                  </button>
                </div>
              </ng-container>
            </div>
          </td>
        </ng-container>
      </tr>

      <!-- Expandable Row -->
      <tr [nzExpand]="expandSet.has(data.id)">
        <td [attr.colspan]="columns.length + 2" class="d-flex flex-row">
          <div class="status-container">
            <div class="status-item">
              <div class="status-circle pending"></div>
              <div class="status-count">{{ data?.pending }}</div>
              <div class="status-name">Pending</div>
            </div>
            <div class="status-item">
              <div class="status-circle fit"></div>
              <div class="status-count">{{ data?.fit }}</div>
              <div class="status-name">Fit</div>
            </div>
            <div class="status-item">
              <div class="status-circle not-fit"></div>
              <div class="status-count">{{ data?.notFit }}</div>
              <div class="status-name">Not Fit</div>
            </div>
          </div>
        </td>
      </tr>
    </ng-container>
  </tbody>
</nz-table>

<!-- numeric pagination controls -->
<ng-container *ngIf="hasPagination">
  <pagination-controls
    *ngIf="autoHidePagination || totalItems > paginationModel?.pageSize"
    (pageChange)="onPaginate($event)"
    class="my-pagination"
    maxSize="5"
    responsive="true"
    [previousLabel]="translate.instant('dashboard.prev')"
    [nextLabel]="translate.instant('dashboard.next')"
  ></pagination-controls>
  <div class="d-flex justify-content-end gap-5">
    <span
      class="mx-5"
      [translatable]="{
        transKey: 'dashboard.prev',
        modEnum: translationModulesEnum[modEnum]
      }"
    ></span>
    <span
      class="mx-5"
      [translatable]="{
        transKey: 'dashboard.next',
        modEnum: translationModulesEnum[modEnum]
      }"
    ></span>
  </div>
</ng-container>
